import { Badge } from '@aimsos/ui';
import { Check, Circle } from 'lucide-react';

/**
 * Three-state read-out for an integration's exposure to a distribution surface
 * (CT-4206): Available / Disabled / N/A. Shared by the distribution table cell
 * and the settings panel so the two never drift. `null`/`undefined` renders as
 * N/A (the integration lacks the capability the surface consumes).
 *
 * @param {object} props
 * @param {boolean|null|undefined} props.value — true=available, false=disabled, nullish=N/A
 * @param {(key: string) => string} props.t — translator from useTranslation('admin-studio')
 * @param {'small'|'medium'} [props.size='medium'] — badge size
 * @param {boolean} [props.withIcon=true] — show the leading state icon
 */
function SurfaceStatus({ value, t, size = 'medium', withIcon = true }) {
  if (value == null) {
    return <span className="text-[13px] text-content-faint">{t('integrations.distribution.na')}</span>;
  }
  return (
    <Badge
      variant={value ? 'success' : 'neutral'}
      size={size}
      radius={size === 'small' ? 'full' : undefined}
      icon={withIcon ? (value ? Check : Circle) : undefined}
    >
      {t(value ? 'integrations.distribution.available' : 'integrations.distribution.disabled')}
    </Badge>
  );
}

export default SurfaceStatus;
